import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import companyIcon from '../../images/svg/companyIcon.svg';
import { PostsContext } from "../../context/posts";
import { Editor, EditorState, convertFromRaw } from 'draft-js';

const CardWrapper = styled.div`
    margin: 0 auto;
    display:flex;
    flex-direction: column;
    margin-top:0.9rem;
    padding-top:0.68rem;
    background:white;
    box-shadow: 0 0 5px #3a393977;
    width:500px;
    border-radius:5px;
    height: auto;

    p{
        margin-left:0.75rem;    
        margin-right:0.75rem;    
    }

`
const HeaderCard = styled.div`
    padding-left:0.75rem;
    padding-right:0.75rem;
    display:flex;
    align-items: center;
    justify-content:space-between;

`
const BodyCard = styled.div`
    margin-top: 0.5rem;

`
const CardText = styled.div`
    display:flex;
    flex-direction: column;
    margin-left:0.5rem;
    p{
        height:0px;
    }

    .textPrimary{
        font-size: 0.91rem;
        color:#080809;
        height:0.4rem;
    }

    .textSecondary{
        font-size: 0.75rem;
        color:#65686C;
        height:0.2rem;

    }

    .timePost{
        color:#484848;
        font-size: 0.75rem;
        font-weight: 600;

    }

`
const CardFlex = styled.div`
    display: flex;
    align-items: center;
`
const Image = styled.img`
    width: 40px;
    height: 40px;
    border-radius:100px;


`
const ContainerImage = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    border-top: 1px solid #dddddd;
    border-bottom: 1px solid #dddddd;

`
const CentralImage = styled.img`
    width: 290px;
    height: 290px;
`
const ContainerDescription = styled.div`
    padding-left:0.75rem;
    padding-right:0.75rem;

`

const PreviewFacebook = () => {
    const { previewNameFacebook,imagePreview,setDescriptionPost} = useContext(PostsContext)
    const [editorState, setEditorState] = useState(() => EditorState.createEmpty()); // Estado inicial vazio do Editor


    useEffect(() => {
        if (previewNameFacebook.length > 0) {

            const contentState = convertFromRaw(JSON.parse(previewNameFacebook));
            setEditorState(EditorState.createWithContent(contentState));
            setDescriptionPost(contentState)
        }

    }, [previewNameFacebook])

    return (
        <CardWrapper>
            <HeaderCard>
                <CardFlex>
                    <Image src={companyIcon} />
                    <CardText>
                        <p className="textPrimary">TKG Engates de Reboque</p>
                        <p className="textSecondary">Publicado por App Tkg</p>
                        <p className="timePost">Agora mesmo <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.509 6.43902C12.509 8.86152 10.979 10.9263 8.83172 11.716L8.88422 11.689C9.75947 10.939 10.2447 9.46376 10.3842 8.81351C10.5447 8.06351 10.6115 7.83851 10.0092 7.34351C9.77672 7.15376 9.50147 7.19653 9.22922 6.98653C9.04472 6.84403 8.96223 6.54402 8.77473 6.43902C8.32923 6.18627 7.94447 6.52151 7.30922 6.60626C7.01844 6.639 6.72401 6.60751 6.44672 6.51402C6.44147 6.51402 6.44147 6.51402 6.43697 6.51102L6.37472 6.48853C6.25172 6.42703 6.31698 6.33401 6.37923 6.21851H6.37472C6.43922 6.09101 6.43923 5.93652 6.33723 5.82177C6.19473 5.66127 5.93223 5.66127 5.73423 5.65377C5.65473 5.65152 5.57672 5.65377 5.49947 5.65677L5.49722 5.65377C5.46722 5.65377 5.43422 5.65677 5.40422 5.65677H5.37647C5.13422 5.66202 4.87697 5.63127 4.70672 5.42127C4.50947 5.15652 4.48922 4.87152 4.77947 4.60378C4.98947 4.40878 5.42672 4.00377 6.13472 4.43877C6.58697 4.71627 7.00922 4.93902 7.38422 4.81377C7.63172 4.73127 7.74422 4.58653 7.45472 4.16128C7.33944 4.00287 7.28271 3.80935 7.29422 3.61377C7.34447 3.03177 7.80947 2.98376 8.16722 2.71376C8.51672 2.44676 8.67723 2.00651 8.57673 1.62101C8.49723 1.31126 8.19422 0.966275 7.61672 0.863525C8.97053 1.0396 10.2139 1.70266 11.1144 2.72878C12.0149 3.75489 12.5102 5.0738 12.509 6.43902Z" fill="#65686C" />
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.46423 11.8361C7.6258 12.0818 6.74165 12.1288 5.8819 11.9733C5.02214 11.8179 4.21043 11.4643 3.51115 10.9405C2.81187 10.4167 2.24425 9.73717 1.85332 8.95581C1.46239 8.17445 1.25889 7.31275 1.25898 6.43905C1.25783 5.50275 1.49105 4.58105 1.93736 3.75797C2.38368 2.9349 3.02891 2.23664 3.81422 1.72681C3.25315 2.19013 2.8253 2.79424 2.57447 3.47729C2.00972 5.14004 2.41173 6.53355 4.29198 6.53355C4.91673 6.53355 5.34198 6.9543 5.29173 8.3148C5.28198 8.61705 5.68173 9.64979 7.12923 9.73229C7.65423 9.76229 8.01722 10.5221 8.12672 11.0373C8.17172 11.2548 8.22198 11.5248 8.31948 11.7648C8.332 11.7913 8.3531 11.8129 8.37936 11.8259C8.40562 11.839 8.43552 11.8421 8.46423 11.8361Z" fill="#65686C" />
                            <path d="M12.884 6.43896C12.884 8.03026 12.2518 9.55639 11.1266 10.6816C10.0014 11.8068 8.47527 12.439 6.88397 12.439C5.29267 12.439 3.76655 11.8068 2.64133 10.6816C1.51611 9.55639 0.883972 8.03026 0.883972 6.43896C0.883972 4.84767 1.51611 3.32154 2.64133 2.19632C3.76655 1.0711 5.29267 0.438965 6.88397 0.438965C8.47527 0.438965 10.0014 1.0711 11.1266 2.19632C12.2518 3.32154 12.884 4.84767 12.884 6.43896ZM12.134 6.43896C12.134 5.04658 11.5808 3.71123 10.5963 2.72666C9.61172 1.7421 8.27636 1.18896 6.88397 1.18896C5.49159 1.18896 4.15623 1.7421 3.17166 2.72666C2.1871 3.71123 1.63397 5.04658 1.63397 6.43896C1.63397 7.83135 2.1871 9.1667 3.17166 10.1513C4.15623 11.1358 5.49159 11.689 6.88397 11.689C8.27636 11.689 9.61172 11.1358 10.5963 10.1513C11.5808 9.1667 12.134 7.83135 12.134 6.43896Z" fill="#65686C" />
                        </svg>
                        </p>
                    </CardText>
                </CardFlex>
                <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.694 10.8589C12.694 11.3893 12.4833 11.898 12.1082 12.2731C11.7331 12.6482 11.2244 12.8589 10.694 12.8589C10.1635 12.8589 9.65483 12.6482 9.27975 12.2731C8.90468 11.898 8.69397 11.3893 8.69397 10.8589C8.69397 10.3285 8.90468 9.81974 9.27975 9.44467C9.65483 9.0696 10.1635 8.85889 10.694 8.85889C11.2244 8.85889 11.7331 9.0696 12.1082 9.44467C12.4833 9.81974 12.694 10.3285 12.694 10.8589ZM18.694 10.8589C18.694 11.3893 18.4833 11.898 18.1082 12.2731C17.7331 12.6482 17.2244 12.8589 16.694 12.8589C16.1635 12.8589 15.6548 12.6482 15.2798 12.2731C14.9047 11.898 14.694 11.3893 14.694 10.8589C14.694 10.3285 14.9047 9.81974 15.2798 9.44467C15.6548 9.0696 16.1635 8.85889 16.694 8.85889C17.2244 8.85889 17.7331 9.0696 18.1082 9.44467C18.4833 9.81974 18.694 10.3285 18.694 10.8589ZM6.69397 10.8589C6.69397 11.3893 6.48326 11.898 6.10818 12.2731C5.73311 12.6482 5.2244 12.8589 4.69397 12.8589C4.16354 12.8589 3.65483 12.6482 3.27975 12.2731C2.90468 11.898 2.69397 11.3893 2.69397 10.8589C2.69397 10.3285 2.90468 9.81974 3.27975 9.44467C3.65483 9.0696 4.16354 8.85889 4.69397 8.85889C5.2244 8.85889 5.73311 9.0696 6.10818 9.44467C6.48326 9.81974 6.69397 10.3285 6.69397 10.8589Z" fill="#65686C" />
                </svg>

            </HeaderCard>
            <BodyCard>
                <ContainerDescription>
                    <Editor
                        readOnly={true}
                        editorState={editorState}
                        onChange={() => <></>}
                    />
                </ContainerDescription>
                <ContainerImage>
                    {imagePreview 
                    
                    ?
                    <CentralImage src={imagePreview} />                
                    :
                    <></>
                    }
                </ContainerImage>
            </BodyCard>

        </CardWrapper>
    )
}

export default PreviewFacebook